export const sharing = {
    home: {
        ogUrl: `https://ttc-aag.netlify.com`,
        ogTitle: `Avatar Generator Exercise by TTC Labs`,
        ogDesc: `I created an avatar from a photo to learn about machine learning labeling bias. I learned that it’s important to have diverse people, labels and images training AI. How do you compare? Make one yourself at ttc-aag.netlify.com`,
        ogImage: `https://ttc-aag.netlify.com/images/preview.png`,
        ogType: `website`,
      
        twCard: `summary_large_image`,
        twSite: `@ttclabs`,
    },
    myAvatars: {
        ogDesc: `I created an avatar from a photo to learn about machine learning labeling bias. I learned that it’s important to have diverse people, labels and images training AI. Check out the avatar I created with machine learning labels and make one yourself at  https://ttc-aag.netlify.com/myavatar`,
        ogImage: `https://ttc-aag.netlify.com/images/preview.png`,
    },
};
